import * as React from 'react';
import { SVGProps } from 'react';

const IconShareSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12.75 5.665a2.5 2.5 0 0 1-2.636-.084L6.99 7.77a2.53 2.53 0 0 1-.028.668l3.047 2.056a2.5 2.5 0 1 1-.994 1.742l-3.162-2.133a2.5 2.5 0 1 1 .161-4.092l3.019-2.113a2.5 2.5 0 1 1 3.718 1.767Z" />
  </svg>
);
export default IconShareSizeS;
